export default "__VITE_ASSET__Uf0bs8II__"